import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { resourceExplorerChartDataSelector } from "./resourceExplorerChartDataSelector";
import { aggregateResourceExplorerPercentBasedChartData } from "../../../utils/helpers/aggregateResourceExplorerPercentBasedChartData";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";

export const resourceExplorerPercentBasedChartDataSelector =
  createDraftSafeSelector(
    [resourceExplorerChartDataSelector],
    (chartData): HighchartsChartDataType | null => {
      return aggregateResourceExplorerPercentBasedChartData(chartData);
    },
  );
